import {
  AppstoreAddOutlined,
  BarChartOutlined,
  AppstoreOutlined,
  ChromeOutlined,
  DashboardOutlined,
  LogoutOutlined,
  QuestionOutlined,
  SettingOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  ToolOutlined,
} from '@ant-design/icons';
import { MenuProps } from 'antd';

export const CHROME_WEB_STORE_URL =
  'https://chromewebstore.google.com/detail/sellsen/obeahpijnjckkafndjdndhjcmldclohm';

export const CHROME_EXTENSION_MENU_KEY = 'chrome-extension';

export const MENU_PATHS = [
  {
    key: '1',
    path: '/',
  },
  {
    key: '2-1',
    path: '/search-by-store',
  },
  {
    key: '2-2',
    path: '/search-by-keyword',
  },
  {
    key: '2-3',
    path: '/asin-pool',
  },
  {
    key: '4-2',
    path: '/pricing',
  },
  {
    key: '5-1',
    path: '/currency-exchange',
  },
  {
    key: '5-2',
    path: '/marketplace-info',
  },
  {
    key: '4-1',
    path: '/product-search',
  },
  {
    key: '4-4',
    path: '/restriction-checks',
  },
  {
    key: 'settings',
    path: '/settings',
  },
  {
    key: 'support',
    path: '/support-request',
  },
  {
    key: 'logout',
    path: '/logout',
  },
  {
    key: '6-1',
    path: '/oauth-management',
  },
  {
    key: '6-2',
    path: '/promotions',
  },
  {
    key: '4-3',
    path: '/product-staging',
  },
  {
    key: '7-2-1',
    path: '/banned/categories',
  },
  {
    key: '7-2-2',
    path: '/banned/brands',
  },
  {
    key: '7-2-3',
    path: '/banned/asins',
  },
  {
    key: '7-2-4',
    path: '/banned/keywords',
  },
  {
    key: '7-2-5',
    path: '/banned/common-brands',
  },
  {
    key: '7-2-6',
    path: '/banned/common-asins',
  },
  {
    key: '7-2-7',
    path: '/banned/common-categories',
  },
  {
    key: '7-2-8',
    path: '/banned/common-keywords',
  },
  {
    key: '7-1',
    path: '/inventories',
  },
  {
    key: '7-4',
    path: '/inventory-update-history',
  },
  {
    key: '7-5',
    path: '/business-reports',
  },
  {
    key: '7-3',
    path: '/marketplace-filter-settings',
  },
  {
    key: '8-1',
    path: '/orders',
  },
  {
    key: '8-2',
    path: '/order-dashboard',
  },
  {
    key: '8-3',
    path: '/order-tracking',
  },
  {
    key: '9-1',
    path: '/warehouse-cases',
  },
  {
    key: '9-2',
    path: '/warehouse-credit',
  },
  {
    key: '9-3',
    path: '/warehouse-info',
  },
  {
    key: '10-1',
    path: '/daily-stats',
  },
];

/**
 * Yalnız satıcının (ROLE_SELLER / ROLE_ADMIN) gördüğü üst menüler: Ürün, Envanter, Sipariş,
 * Depo, İstatistikler, Mağazam. ASIN-only kullanıcı (ROLE_USER) Dashboard, Asin Yönetimi ve Araçlar'ı görür.
 * Route tarafındaki karşılığı `RequireSellerAccess`; ikisi birlikte değiştirilmeli.
 */
export const SELLER_MENU_KEYS: ReadonlySet<string> = new Set([
  '4',
  '7',
  '8',
  '9',
  '10',
  '6',
]);

export const filterMenuItemsForSeller = (
  items: MenuProps['items'],
  isSeller: boolean
): MenuProps['items'] => {
  if (isSeller || !items) {
    return items;
  }
  return items.filter(
    (item) =>
      !item || !('key' in item) || !SELLER_MENU_KEYS.has(String(item.key))
  );
};

export const MENU_ITEMS = [
  {
    key: '1',
    icon: <DashboardOutlined />,
    label: 'Dashboard',
  },
  {
    key: '2',
    icon: <ShoppingOutlined />,
    label: 'Asin Yönetimi',
    children: [
      {
        key: '2-1',
        label: 'Mağaza Taraması',
      },
      {
        key: '2-2',
        label: 'Anahtar Kelime Taraması',
      },
      {
        key: '2-3',
        label: 'Asin Havuzu',
      },
    ],
  },

  {
    key: '4',
    icon: <AppstoreAddOutlined />,
    label: 'Ürün Yönetimi',
    children: [
      {
        key: '4-1',
        label: 'Ürün Arama',
      },
      {
        key: '4-4',
        label: 'Kısıtlılık Kontrolü',
      },
      {
        key: '4-3',
        label: 'Ürün Havuzu',
      },
    ],
  },
  {
    key: '7',
    icon: <AppstoreOutlined />,
    label: 'Envanter Yönetimi',
    children: [
      {
        key: '7-1',
        label: 'Envanter Listeleme',
      },
      {
        key: '4-2',
        label: 'Fiyatlandırma',
      },
      {
        key: '7-3',
        label: 'Filtre Ayarları',
      },
      {
        key: '7-2',
        label: 'Envanter Güvenliği',
        children: [
          {
            key: '7-2-1',
            label: 'Yasaklı Kategori',
          },
          {
            key: '7-2-2',
            label: 'Yasaklı Marka',
          },
          {
            key: '7-2-3',
            label: 'Yasaklı Ürün',
          },
          {
            key: '7-2-4',
            label: 'Yasaklı Kelime',
          },
          {
            key: '7-2-5',
            label: 'Ortak Marka Havuzu',
          },
          {
            key: '7-2-6',
            label: 'Ortak ASIN Havuzu',
          },
          {
            key: '7-2-7',
            label: 'Ortak Kategori Havuzu',
          },
          {
            key: '7-2-8',
            label: 'Ortak Kelime Havuzu',
          },
        ],
      },
      {
        key: '7-4',
        label: 'Envanter Güncelleme Geçmişi',
      },
      {
        key: '7-5',
        label: 'Business Reports',
      },
    ],
  },
  {
    key: '8',
    icon: <ShoppingCartOutlined />,
    label: 'Sipariş Yönetimi',
    children: [
      {
        key: '8-2',
        label: 'Sipariş Dashboard',
      },
      {
        key: '8-3',
        label: 'Sipariş Takip',
      },
      {
        key: '8-1',
        label: 'Sipariş Listeleme',
      },
    ],
  },
  {
    key: '9',
    icon: <ShopOutlined />,
    label: 'Depo Yönetimi',
    children: [
      {
        key: '9-2',
        label: 'Depo İşlemleri',
      },
      {
        key: '9-1',
        label: 'Depo Mesajları',
      },
      {
        key: '9-3',
        label: 'Depo Bilgileri',
      },
    ],
  },
  {
    key: '10',
    icon: <BarChartOutlined />,
    label: 'İstatistikler',
    children: [
      {
        key: '10-1',
        label: 'Günlük İstatistikler',
      },
    ],
  },
  {
    key: '5',
    icon: <ToolOutlined />,
    label: 'Araçlar',
    children: [
      {
        key: '5-1',
        label: 'Para Birimi',
      },
      {
        key: '5-2',
        label: 'Pazar Alanları',
      },
    ],
  },
  {
    key: '6',
    icon: <ToolOutlined />,
    label: 'Mağazam',
    children: [
      {
        key: '6-1',
        label: 'Mağaza Ayarları',
      },
      {
        key: '6-2',
        label: 'Promosyonlarım',
      },
    ],
  },
];

export const USER_MENU_ITEMS: MenuProps['items'] = [
  {
    key: 'settings',
    icon: <SettingOutlined />,
    label: 'Hesap Ayarları',
  },
  {
    key: CHROME_EXTENSION_MENU_KEY,
    icon: <ChromeOutlined />,
    label: 'Chrome Eklentisini Yükle',
  },
  {
    key: 'support',
    icon: <QuestionOutlined />,
    label: 'Yardım',
  },
  {
    type: 'divider',
  },
  {
    key: 'logout',
    icon: <LogoutOutlined />,
    label: 'Çıkış Yap',
    danger: true,
  },
];

export const getMenuUrl = (key: string): string | undefined => {
  const item = MENU_PATHS.find((menu) => menu.key === key);
  if (item) {
    return item.path;
  }
  return undefined;
};
